class HTMLModule
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'html-module--bound'
            @.consentGiven = false
            @.consentNeeded = @.$el.classList.contains 'html-module--consent-needed'
            @.codeAppended = !@.consentNeeded
            @.$consentButton = if @.consentNeeded then @.$el.querySelector('.html-module__disclaimer-button') else false
            @.$template = @.$el.querySelector 'template'

            @.$el.classList.add 'html-module--bound'
            if @.consentNeeded
                @.InitEvents()
            else
                @.$el.classList.add 'html-module--appended'
        return

    AppendTemplate: ->
        @.$el.classList.add 'html-module--appended'
        @.codeAppended = true
        @.$el.appendChild document.importNode(@.$template.content, true)
        return

    ConsentGiven: ->
        @.consentGiven = true
        @.$el.classList.add 'html-module--consent-given'
        @.AppendTemplate()
        return

    InitEvents: ->
        self = @
        @.$consentButton.addEventListener 'click', (e) ->
            e.preventDefault()
            self.ConsentGiven()
            return
        return

BindHTMLModules = ->
    document.querySelectorAll '.html-module:not(.html-module--bound)'
        .forEach (el) ->
            new HTMLModule el
            return
    return

window.addEventListener 'bind-components', BindHTMLModules